import { ListSortDirection, Sort } from "../../models/api/sort";
import { EmployeeDependentDTO, EmployeeDependentsFilter, EmployeeDependentSTO } from "../../models/employee-dependents";
import { BaseApiService } from "../base/base-api.service";

export class EmployeesDependentsApiService extends BaseApiService<EmployeeDependentDTO, EmployeeDependentSTO> {
  constructor() {
    super({
      servicePath: "/EmployeesDependents",
      loadItemsPath: "/GetEmployeesDependents",
      saveItemsPath: "/SaveEmployeesDependents",
    });
    this.defaultSort = [
      {
        name: "employee.firstName",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "employee.lastName",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "firstName",
        direction: ListSortDirection.Ascending,
      } as Sort,
      {
        name: "lastName",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}

export const loadEmployeeDependents = async (employeeId: string, forManager: boolean, signal?: AbortSignal) => {
  const apiService = new EmployeesDependentsApiService();
  if (!forManager) {
    apiService.useLoadItemsPath("/GetCurrentUserEmployeesDependents");
  }

  const response = await apiService.loadItems(
    !forManager
      ? ({ employeeId } as EmployeeDependentsFilter)
      : ({ employeeIds: [employeeId] } as EmployeeDependentsFilter),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    signal
  );

  return response;
};
